/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SecurityAccessFeaturesEnum = {
    Dashboard: 'Dashboard',
    MyClients: 'MyClients',
    NewBusiness: 'NewBusiness',
    Transact: 'Transact',
    Guides: 'Guides',
    MyPractice: 'MyPractice',
    Tracking: 'Tracking',
    OnlineSupport: 'OnlineSupport',
    Tools: 'Tools',
    Legal: 'Legal',
    ProposalOverview: 'ProposalOverview',
    CreateProposal: 'CreateProposal',
    EditProposal: 'EditProposal',
    DeleteProposal: 'DeleteProposal',
    DuplicateProposal: 'DuplicateProposal',
    RequestSpecialQuote: 'RequestSpecialQuote',
    RequestUpdate: 'RequestUpdate',
    Requote: 'Requote',
    ProposalOverride: 'ProposalOverride',
    StartApplication: 'StartApplication',
    SubmitESign: 'SubmitESign',
    InOfficeESign: 'InOfficeESign',
    FinalizeApplication: 'FinalizeApplication',
    AllowActingAs: 'AllowActingAs',
    WillDrafter: 'WillDrafter',
    AllowActingAsAll: 'AllowActingAsAll',
    Settings: 'Settings'
} as const;
export type SecurityAccessFeaturesEnum = typeof SecurityAccessFeaturesEnum[keyof typeof SecurityAccessFeaturesEnum];


export function SecurityAccessFeaturesEnumFromJSON(json: any): SecurityAccessFeaturesEnum {
    return SecurityAccessFeaturesEnumFromJSONTyped(json, false);
}

export function SecurityAccessFeaturesEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecurityAccessFeaturesEnum {
    return json as SecurityAccessFeaturesEnum;
}

export function SecurityAccessFeaturesEnumToJSON(value?: SecurityAccessFeaturesEnum | null): any {
    return value as any;
}

